
import { Flight } from "@/types/flight";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FIDSFlightBoard } from "@/components/fids/FIDSFlightBoard";
import { AirportSelector } from "@/components/AirportSelector";

interface FlightTabsProps {
  todaysFlights: Flight[];
  allFlights: Flight[];
  searchTerm?: string;
  onFlightClick?: (flight: Flight) => void;
}

export function FlightTabs({ todaysFlights, allFlights, searchTerm = "", onFlightClick }: FlightTabsProps) {
  return (
    <main className="overflow-hidden" style={{ backgroundColor: "#0a0f2c" }}>
      <Tabs defaultValue="all-flights" className="w-full">
        <div style={{ backgroundColor: "#0d1b4b" }}>
          <TabsList className="grid w-full grid-cols-2 h-12 bg-transparent rounded-none">
            <TabsTrigger
              value="all-flights"
              className="text-base text-white/70 font-bold data-[state=active]:text-white data-[state=active]:bg-[#00c8d7] rounded-none"
            >
              All Flights ({todaysFlights.length})
            </TabsTrigger>
            <TabsTrigger
              value="by-airport"
              className="text-base text-white/70 font-bold data-[state=active]:text-white data-[state=active]:bg-[#00c8d7] rounded-none"
            >
              By Airport
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="all-flights" className="mt-0">
          <FIDSFlightBoard flights={todaysFlights} mode="all" searchTerm={searchTerm} onFlightClick={onFlightClick} />
        </TabsContent>

        <TabsContent value="by-airport" className="mt-0 p-6">
          <AirportSelector flights={allFlights} />
        </TabsContent>
      </Tabs>
    </main>
  );
}
